import { doc, runTransaction } from "firebase/firestore";
import pLimit from "p-limit";
import { useCallback } from "react";
import { db } from "../../config/firebase";
import Route from "../../models/Route";

export function useUpsertRoutes() {
  const mutateAsync = useCallback(async (routesData) => {
    try {
      const limit = pLimit(10);

      const tasks = routesData.map((routeData) =>
        limit(async () => {
          try {
            await runTransaction(db, async (transaction) => {
              const docRef = doc(db, "routes", routeData.id);
              const snapshot = await transaction.get(docRef);
              const payload = snapshot.exists() ? Route.toJSONUpdate(routeData) : Route.toJSON(routeData);

              transaction.set(docRef, payload, { merge: true });
            });

            return { id: routeData.id, success: true, error: null };
          } catch (err) {
            return { id: routeData.id, success: false, error: err };
          }
        }),
      );

      const result = await Promise.all(tasks);
      const errors = result.filter((item) => !item.success);

      if (errors.length) {
        const errorMessage = errors.map((e) => `\n${e.id}: ${e.error?.message ?? "missing-error-message"}`).join(";");
        const message = `Failed to upsert ${errors.length} route(s): ${errorMessage}`;
        console.error(message);
        const error = new Error(message);

        return { success: false, error };
      }

      return { count: routesData.length, success: true, error: null };
    } catch (error) {
      console.error("Failed to upsert route(s)", error);

      return { success: false, error };
    }
  }, []);

  return { mutateAsync };
}
